export const addClickCallback = (config, clickCallbackFns) =>
    config.map(columnConfig => columnConfig.name && clickCallbackFns[columnConfig.name] ?
        {...columnConfig, click_callback: clickCallbackFns[columnConfig.name]}
        : columnConfig
    );
export const addCustomRenderer = (config, customRenderFns) =>
    config.map(columnConfig => columnConfig.name && customRenderFns[columnConfig.name] ?
        {...columnConfig, custom_render: customRenderFns[columnConfig.name]}
        : columnConfig
    );